import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../src/environments/environment';
import { ProcessStructure } from '../models/processAuto.model';

@Injectable({
  providedIn: 'root',
})
export class ProcessAutoService {
  private apiServerUrl = environment.loganConfig.url;

  constructor(private http: HttpClient) {}

  headers = new HttpHeaders().set('Content-Type', 'text/plain; charset=utf-8');
  requestOptions: Object = {
    headers: this.headers,
    responseType: 'text',
    withCredentials: true,
  };

  public createProcess(
    processStructureLst: ProcessStructure[]
  ): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/api/processAuto/createProcessAutoStructure`,
      processStructureLst,
    );
  }

  public getProcessStructure(): Observable<any> {
    return this.http.get<any>(
      `${this.apiServerUrl}/api/processAuto/processStructures`
    );
  }

  public getProcessItemsBySerial(serials: string[]): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/api/processAuto/processStructureItemsBySerial`,
      serials,
      { withCredentials: true }
    );
  }
  public includeInGroup(
    serials: string,
    group: string,
    userId: number
  ): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/api/processAuto/processAutoincludeSerialInGroup`,
      { seriais: serials, group: group, userId: userId },
      { withCredentials: true }
    );
  }
  public resetAttempts(serials: string, userId: number): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/api/processAuto/processAutoResetAttempts`,
      { seriais: serials, userId: userId },
      { withCredentials: true }
    );
  }
  public resetProcessItem(
    serials: string,
    currentStep: number,
    userId: number
  ): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/api/processAuto/processAutoResetProcessItem`,
      { seriais: serials, currentStep: currentStep, userId: userId },
      { withCredentials: true }
    );
  }
  public removeDuplicatedSameProcessGroup(
    id: string,
    userId: number
  ): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/api/processAuto/processAutoRemoveDuplicatedSameProcessGroup`,
      { ids: id, userId: userId },
      { withCredentials: true }
    );
  }
}
